// import React, { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { Card, Button, Spinner } from 'react-bootstrap';
// import Navbar from './Navbar'; // Adjust the path if necessary
// import { cards } from '../components/SliderComp'; // Your data file
// import axios from 'axios';
// import Muskaan from '../assets/Initiatives/Muskaan.png';
// import '../css/project.css';
// import Footer from "../components/Footer";
// import BackToTop from "../components/BackToTop";

// function Projects() {
// const { id } = useParams(); // Get card ID from the route
// const [card, setCard] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();
//   const blogs = [
//     {
//       id: 1,
//       title: "Exploring the Mountains",
//       description: "A breathtaking journey through the world's highest peaks.",
//       image: Muskaan,
//     },
//     {
//       id: 2,
//       title: "Futuristic Technology Trends",
//       image: Muskaan,
//     },
//     {
//       id: 3,
//       title: "Healthy Eating Habits",
//       image: Muskaan,
//     },
//     {
//       id: 4,
//       title: "Best Travel Destinations",
//       image: Muskaan,
//     },
//     {
//       id: 5,
//       title: "Artificial Intelligence Impact",
//       image: Muskaan,
//     },
//   ];
//   useEffect(() => {
//     // Find the card locally
//     const selectedCard = cards.find((c) => c.id === parseInt(id));
//     if (!selectedCard) {
//       setLoading(false);
//       return;
//     }

//     setCard(selectedCard);
//     setLoading(false);
//   }, [id]);

//   if (loading) {
//     return (
//       <div className="text-center mt-5">
//         <Spinner animation="border" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </Spinner>
//       </div>
//     );
//   }

//   if (!card) {
//     return <div>Project not found.</div>;
//   }

//   // Split projects into chunks of 4 for each row
//   const projectRows = [];
//   for (let i = 0; i < card.projects.length; i += 4) {
//     projectRows.push(card.projects.slice(i, i + 4));
//   }

//   const handleCardClick = async (projectId) => {
//     try {

//       // const response = await axios.post('https://api.nhrf.com/getBlogOfProject', { id: projectId });

//       // if (response.data) {
//       //   navigate(`/blog/${projectId}`, { state: { blogData: response.data } });
//       // }

//       const data = {
//         "Title": "Empowering Health Awareness",
//         "Name": "HealthDome Project",
//         "Description": "The HealthDome initiative aims to raise awareness about health and wellness while providing support to those in need. It promotes a healthier lifestyle for the community.",
//         "Image": Muskaan,
//         "blogs": [
//           {
//             "Id": 1,
//             "Title": "Understanding Nutritional Needs",
//             "Image1": Muskaan,
//             "desc": "The HealthDome initiative aims to raise awareness about health and wellness while providing support to those in need. It promotes a healthier lifestyle for the communityThe HealthDome initiative aims to raise awareness about health and wellness while providing support to those in need. It promotes a healthier lifestyle for the communityThe HealthDome initiative aims to raise awareness about health and wellness while providing support to those in need. It promotes a healthier lifestyle for the communityThe HealthDome initiative aims to raise awareness about health and wellness while providing support to those in need. It promotes a healthier lifestyle for the communityThe HealthDome initiative aims to raise awareness about health and wellness while providing support to those in need. It promotes a healthier lifestyle for the communityThe HealthDome initiative aims to raise awareness about health and wellness while providing support to those in need. It promotes a healthier lifestyle for the communityThe HealthDome initiative aims to raise awareness about health and wellness while providing support to those in need. It promotes a healthier lifestyle for the communityThe HealthDome initiative aims to raise awareness about health and wellness while providing support to those in need. It promotes a healthier lifestyle for the communityThe HealthDome initiative aims to raise awareness about health and wellness while providing support to those in need. It promotes a healthier lifestyle for the community"
//           },
//           {
//             "Id": 2,
//             "Title": "The Importance of Regular Exercise",
//             "Image1": Muskaan,
//             "desc": "Blog Post on Exercise"
//           },
//           {
//             "Id": 3,
//             "Title": "Mental Health Awareness",
//             "Image1": Muskaan,
//             "desc": "Blog Post on Mental Health"
//           },
//           {
//             "Id": 4,
//             "Title": "Preventive Healthcare Practices",
//             "Image1": Muskaan,
//             "desc": "Blog Post on Preventive Healthcare"
//           }
//         ]
//       };
//       if (data) {
//         navigate(`/blog/${projectId}`, { state: { blogData: data } });
//       }



//     } catch (error) {
//       console.error('Error fetching blog data:', error);
//       alert('Failed to fetch blog details. Please try again.');
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="blog-container">
//         {/* Left Section - Featured Blog */}
//         <div className="featured-blog">
//           <img src={blogs[0].image} alt={blogs[0].title} className="featured-image" />
//           <h2>{blogs[0].title}</h2>
//           <p>{blogs[0].description}</p>
//         </div>

//         {/* Right Section - Scrollable Blog List */}
//         <div className="blog-list">
//           {blogs.slice(1).map((blog) => (
//             <div key={blog.id} className="blog-item">
//               <img src={blog.image} alt={blog.title} className="blog-thumbnail" />
//               <h4>{blog.title}</h4>
//             </div>
//           ))}
//         </div>
//       </div>
//       <Footer />
//       <BackToTop />
//     </>

//   );

// }

// export default Projects;



// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import Navbar from './Navbar';
// import { cards } from '../components/SliderComp';
// import Footer from '../components/Footer';
// import BackToTop from '../components/BackToTop';
// import Muskaan from '../assets/Initiatives/Muskaan.png';

// const Projects = () => {
//   const { id } = useParams();
//   const [card, setCard] = useState(null);
//   const [loading, setLoading] = useState(true);
//   // const navigate = useNavigate();

// useEffect(() => {
//   const selectedCard = cards.find((c) => c.id === parseInt(id));
//   setCard(selectedCard || null);
//   setLoading(false);
// }, [id]);

// if (loading) {
//   return <div className="text-center mt-10 text-xl font-semibold">Loading...</div>;
// }

// if (!card) {
//   return <div className="text-center mt-10 text-xl font-bold text-red-500">Project not found.</div>;
// }

//   const blogs = [
//     { id: 1, title: "Exploring the Mountains", image: Muskaan },
//     { id: 2, title: "Futuristic Technology Trends", image: Muskaan },
//     { id: 3, title: "Healthy Eating Habits", image: Muskaan },
//     { id: 4, title: "Best Travel Destinations", image: Muskaan },
//     { id: 5, title: "Artificial Intelligence Impact", image: Muskaan },
//   ];

//   return (
//     <>
//       <Navbar />
//       {/* Project Image with Animation */}
//       <motion.div
//         className="w-full h-[70vh] overflow-hidden relative"
//         initial={{ opacity: 0, y: -50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 1 }}
//       >
//         <img src={Muskaan} alt="Project" className="w-full h-full object-cover" style={{

//               height: '480px'

//         }} />
//         <motion.div
//           className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ delay: 0.5 }}
//         >
//           <h1 className="text-5xl font-extrabold text-white drop-shadow-lg">
//             {card.name}
//           </h1>
//         </motion.div>
//       </motion.div>

// {/* Project Description */}
// <motion.div
//   className="max-w-4xl mx-auto p-6 text-lg leading-7"
//   initial={{ opacity: 0 }}
//   animate={{ opacity: 1 }}
//   transition={{ delay: 1 }}
// >
//   <h2 className="text-3xl font-bold text-gray-800 mb-4" style={{
//      paddingLeft: '10%',
//      paddingTop:"10px"
//   }}>About the Project</h2>
//   <p className="text-gray-600" style={{
//     paddingLeft: '10%',
//     width: '60%',
//     fontSize: '20px'
//   }}>
//     {"A long and engaging project description would go here...".repeat(20)}
//   </p>
// </motion.div>

//       {/* Scrollable Blog Section */}
//       <div className="max-w-6xl mx-auto mt-12">
//         <h2 className="text-3xl font-bold text-gray-800 mb-4">Related Blogs</h2>
//         <motion.div
//           className="flex space-x-6 overflow-x-scroll scrollbar-hide p-4"
//           whileTap={{ cursor: "grabbing" }}
//         >
//           {blogs.map((blog) => (
//             <motion.div
//               key={blog.id}
//               className="min-w-[250px] bg-white shadow-lg rounded-lg overflow-hidden"
//               whileHover={{ scale: 1.05 }}
//             >
//               <img src={blog.image} alt={blog.title} className="w-full h-40 object-cover" />
//               <div className="p-4">
//                 <h3 className="text-lg font-semibold text-gray-800">{blog.title}</h3>
//               </div>
//             </motion.div>
//           ))}
//         </motion.div>
//       </div>

//       <Footer />
//       <BackToTop />
//     </>
//   );
// };

// export default Projects;

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { cards } from "../components/SliderComp";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import Muskaan from "../assets/Initiatives/Muskaan.png";
import { color, motion } from "framer-motion";
import '../css/blog.css';
import Card from 'react-bootstrap/Card';
import UpperPic1 from "../assets/ninthSection-pic1.jpg"
import UpperPic2 from "../assets/ninthSection-pic2.jpg"
import UpperPic3 from "../assets/ninthSection-pic3.jpg"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"; // Import arrows

import greenathan1 from '../assets/Greenathan/1.jpg';
import '../css/project.css';
import '../css/home.css';
export const blogData = [
  {
    id: 1,
    image: UpperPic1,
    title: "Exploring Nature",
    description: "Discover the beauty of nature with breathtaking landscapes and adventures.",
  },
  {
    id: 2,
    image: UpperPic2,
    title: "The Future of AI",
    description: "An in-depth look at artificial intelligence and its impact on the world.",
  },
  {
    id: 3,
    image: UpperPic3,
    title: "The Mysteries of Space",
    description: "Uncover the wonders of the universe and deep space exploration.",
  },
  {
    id: 4,
    image: UpperPic1,
    title: "Building a Startup",
    description: "Learn the secrets to launching a successful startup from industry leaders.",
  },
];
const Projects = () => {
  const { id } = useParams();
  const [card, setCard] = useState(null);
  const [loading, setLoading] = useState(true);

  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  const selectedCard = cards.find((c) => c.id === parseInt(id));

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % blogData.length);
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? blogData.length - 1 : prevIndex - 1
    );
  };

  // Auto-slide functionality
  useEffect(() => {
    const autoSlide = setInterval(() => {
      handleNext();
    }, 5000); // Change slides every 5 seconds

    return () => clearInterval(autoSlide); // Cleanup on component unmount
  }, []);
  useEffect(() => {
    const selectedCard = cards.find((c) => c.id === parseInt(id));
    setCard(selectedCard || null);
    console.log("Card details", id, selectedCard);

    console.log("Set Card", card);

    setLoading(false);
  }, [id]);


  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + 1 >= selectedCard.projects.length ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex - 1 < 0 ? selectedCard.projects.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 4000); // Auto-slide every 4 seconds
    return () => clearInterval(interval);
  }, [selectedCard.projects.length]);




  if (loading) {
    return <div className="text-center mt-10 text-xl font-semibold">Loading...</div>;
  }

  if (!card) {
    return <div className="text-center mt-10 text-xl font-bold text-red-500">Project not found.</div>;
  }
  const handleBlogClick = (id) => {
    // navigate(`/blog/${id}`);
  };

  const handleProjectClick = (projectId) => {
    navigate(`/projects/${selectedCard.id}/subprojects/${projectId}`);
  };
  
  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          minHeight: "70vh",
          padding: "5vw",
          alignItems: "center",
          justifyContent: "center",
          background: "#f3f2f3",
          gap: "20px",
        }}
      >
        {/* Left Section - Title & Description */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          style={{
            flex: "1",
            minWidth: "300px",
            maxWidth: "500px",
            textAlign: "center",
          }}
        >
          <h1
            style={{
              fontSize: "clamp(2rem, 4vw, 3rem)",
              fontWeight: "bold",
              color: "#333",
            }}
          >
            {selectedCard.title}
          </h1>

        </motion.div>

        {/* Right Section - Project Image */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1.5 }}
          style={{
            flex: "1",
            minWidth: "300px",
            maxWidth: "550px",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
          }}
        >
        <Card className="custom-card">
        <img
            src={selectedCard.image1}
            alt="Project"
            loading="lazy"
            style={{
              width: "100%",
              height: "auto",
              objectFit: "cover",
              borderRadius: "12px",
            }}
            
          />
          <img src={card.leftLogo} alt="Left Logo" className="card-left-logo" />

          <img src={card.rightLogo} alt="Right Logo" className="card-right-logo" style={
            {
             width: selectedCard.title === "Healthdom" ? "150px" : "80px",
            height: selectedCard.title === "Healthdom" ? "60px" : "auto",

            }
          } />

        </Card>
        </motion.div>
      </div>

      {/* Project Description Section */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 1 }}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          width: "100%",
          padding: "40px 5vw",
        }}
      >
        <h2
          style={{
            fontSize: "clamp(2rem, 3vw, 2.5rem)",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "15px",
            textTransform: "uppercase",
            letterSpacing: "1.5px",
          }}
        >
          About the Project
        </h2>
        <p
          className="text-gray-600"
          style={{
            maxWidth: "800px",
            fontSize: "clamp(1rem, 1.5vw, 1.2rem)",
            lineHeight: "1.8",
            color: "#555",
          }}
        >
          {selectedCard.text}
        </p>
      </motion.div>

      {/* Blog Section */}

      {/* Blog Section */}
      {/* <div
        style={{
          width: "100%",
          padding: "40px 5vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "clamp(2rem, 3vw, 2.5rem)",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "20px",
            textTransform: "uppercase",
            letterSpacing: "1.5px",
          }}
        >
          Latest Blogs
        </h2>

        <div
          style={{
            display: "flex",
            gap: "20px",
            overflow: "hidden",
            width: "80%",
          }}
        >
          {blogData.slice(activeIndex, activeIndex + 3).map((blog) => (
            <motion.div
              key={blog.id}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              style={{
                flex: "1",
                minWidth: "300px",
                maxWidth: "400px",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                textAlign: "center",
                background: "#fff",
                paddingBottom: "20px",
              }}
              onClick={() => handleBlogClick(blog.id)} 
            >
              <img
                src={blog.image}
                alt={blog.title}
                style={{ width: "100%", height: "200px", objectFit: "cover" }}
              />
              <h3 style={{ fontSize: "1.5rem", margin: "10px 0", color: "#333" }}>
                {blog.title}
              </h3>
              <p style={{ fontSize: "1rem", color: "#666", padding: "0 10px" }}>
                {blog.description}
              </p>
            </motion.div>
          ))}
        </div>

     
        <button
          onClick={handlePrev}
          style={{
            position: "absolute",
            left: "2vw",
            cursor: "pointer",
            background: "rgba(0, 0, 0, 0.3)",
            border: "none",
            padding: "10px",
            borderRadius: "50%",
            transition: "all 0.3s ease",
          }}
        >
          <FaArrowLeft size={30} color="#fff" />
        </button>

  
        <button
          onClick={handleNext}
          style={{
            position: "absolute",
            right: "2vw",
            cursor: "pointer",
            background: "rgba(0, 0, 0, 0.3)",
            border: "none",
            padding: "10px",
            borderRadius: "50%",
            transition: "all 0.3s ease",
          }}
        >
          <FaArrowRight size={30} color="#fff" />
        </button>
      </div> */}

    {/* {
      selectedCard.projects.length != 0 &&
    (  <div
        style={{
          width: "100%",
          padding: "40px 5vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
          position: "relative",
          background: "rgb(213 193 186)"

        }}
      >
        <div className="home-ninth-section">
          <div className="ninth-container" style={{
            width: '100%',
             background: "rgb(213 193 186)"
          }}>
            <div className="ninth-upper-container">
              <h2>Our {selectedCard.title} Projects</h2>
            
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: "20px",
            overflow: "hidden",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >

          {selectedCard.projects.slice(currentIndex, currentIndex + 2).map((blog, index) => (
            <motion.div
              key={blog.id}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              style={{
                flex: "1",
                minWidth: "280px",
                maxWidth: "480px",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                textAlign: "center",
                background: "#fff",
                paddingBottom: "20px",
              }}
            >

              <img
                src={blog.image}
                alt={blog.id}
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                }}
              />
              <h3
                style={{
                  fontSize: "1.5rem",
                  margin: "10px 0",
                  color: "#333",
                }}
              >
                {blog.title}
              </h3>

            </motion.div>

          ))}

        </div>
      </div>)} */}


{
  selectedCard.projects.length !== 0 && (

    <div className="slider-container">
    <h2 className="slider-title">Our {selectedCard.title} Projects</h2>

    <div className="slider-wrapper">
      {/* Left Arrow */}
      <button className="slider-arrow left" onClick={prevSlide}>
        <FaChevronLeft />
      </button>

      <motion.div
        className="slider"
        animate={{ x: `-${currentIndex * 100}%` }} // Moves left per slide
        transition={{ ease: "easeInOut", duration: 0.8 }}
      >
        {selectedCard.projects.map((blog, index) => (
          <div key={blog.id} className="slide" onClick={() => handleProjectClick(blog.id)}>
            <img src={blog.image} alt={blog.title} className="slide-image" />
            <div className="slide-content">
              <h3 style={{color:'white'}}>{blog.title}</h3>
            </div>
          </div>
        ))}
      </motion.div>

      {/* Right Arrow */}
      <button className="slider-arrow right" onClick={nextSlide}>
        <FaChevronRight />
      </button>
    </div>
  </div>

  )
}









      {/* Blog Section */}



      <div
        style={{
          width: "100%",
          padding: "40px 5vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
          position: "relative",
          background: "#FEF6F3"

        }}
      >
        <div className="home-ninth-section">
          <div className="ninth-container" style={{
            width: '100%'
          }}>
            <div className="ninth-upper-container">
              <h4>Our Blog</h4>
              <h2>Latest Photos & Galleries</h2>
              <p>
                Glimpse of {selectedCard.title} project initiatives.
              </p>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: "20px",
            overflow: "hidden",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {selectedCard.blogs.slice(activeIndex, activeIndex + 3).map((blog) => (
            <motion.div
              key={blog.id}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              style={{
                flex: "1",
                minWidth: "280px",
                maxWidth: "380px",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                textAlign: "center",
                background: "#fff",
                paddingBottom: "20px",
              }}
              onClick={() => handleBlogClick(blog.id)}
            >
              <img
                src={blog.image}
                alt={blog.id}
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                }}
              />
              {/* <h3
                style={{
                  fontSize: "1.5rem",
                  margin: "10px 0",
                  color: "#333",
                }}
              >
                {blog.title}
              </h3>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#666",
                  padding: "0 10px",
                }}
              >
                {blog.description}
              </p> */}
            </motion.div>
          ))}
        </div>

        {/* Custom Left Arrow */}
        <button
          onClick={handlePrev}
          style={{
            position: "absolute",
            left: "2vw",
            cursor: "pointer",
            background: "rgba(0, 0, 0, 0.3)",
            border: "none",
            padding: "10px",
            borderRadius: "50%",
            transition: "all 0.3s ease",
            display: activeIndex === 0 ? "none" : "block",
          }}
        >
          <FaArrowLeft size={30} color="#fff" />
        </button>

        {/* Custom Right Arrow */}
        <button
          onClick={handleNext}
          style={{
            position: "absolute",
            right: "2vw",
            cursor: "pointer",
            background: "rgba(0, 0, 0, 0.3)",
            border: "none",
            padding: "10px",
            borderRadius: "50%",
            transition: "all 0.3s ease",
            display: activeIndex + 3 >= blogData.length ? "none" : "block",
          }}
        >
          <FaArrowRight size={30} color="#fff" />
        </button>
      </div>


      <Footer />
      <BackToTop />
    </>
  );

};

export default Projects;
